import React from 'react';

import {Title, LinkButton, PrimaryButton} from 'components';
import i18n from 'i18next';

type SubHeaderProps = {
  title?: string;
  navigator?: React.ReactNode;
  linkTo: string;
  onClick: () => void;
};

function SubHeader({title, linkTo, onClick, navigator}: SubHeaderProps) {
  return (
    <div className="w-full xl:w-7/12 m-auto">
      <div className="flex justify-between pb-3">
        {title && <Title>{title}</Title>}
        {navigator && navigator}
        <div className="flex">
          <LinkButton to={linkTo}>
            {i18n.t('dashboardPage.subheader.showAll')}
          </LinkButton>
          <PrimaryButton
            className="px-4 py-3 ml-6 primary-btn"
            onClick={onClick}
          >
            {i18n.t('dashboardPage.subheader.newButtonLabel')}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default SubHeader;
